import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertService } from '../../../services/alert';

@Component({
  selector: 'app-alert',
  imports: [CommonModule],
  templateUrl: './alert.html',
  styleUrl: './alert.css'
})
export class Alert {
  alertService = inject(AlertService);
  alerts = this.alertService.getAlerts();

  remove(id: string) {
    this.alertService.remove(id);
  }
}
